import { UserDrawField } from '../../../components/DrawField'
import { GROWERS_ROUTES } from '../../../navigation/types/growersRoutes'
import { LAND_MANAGER_ROUTES } from '../../../navigation/types/routes'

export const GrowerDrawField = () => (
  <UserDrawField
    completeRoute={GROWERS_ROUTES.DETAIL}
    profilingRoute={LAND_MANAGER_ROUTES.PROFILE_FIELDS}
    enrollRoute={GROWERS_ROUTES.DETAIL}
  />
)
